var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "icon-path plus",
    clipRule: "evenodd",
    d: "M17.1667 8.41667H9.58333V0.833333C9.58333 0.483333 9.35 0.25 9 0.25C8.65 0.25 8.41667 0.483333 8.41667 0.833333V8.41667H0.833333C0.483333 8.41667 0.25 8.65 0.25 9C0.25 9.35 0.483333 9.58333 0.833333 9.58333H8.41667V17.1667C8.41667 17.5167 8.65 17.75 9 17.75C9.35 17.75 9.58333 17.5167 9.58333 17.1667V9.58333H17.1667C17.5167 9.58333 17.75 9.35 17.75 9C17.75 8.65 17.5167 8.41667 17.1667 8.41667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.cdd01c276a3f6a0fe5a8f05d9d01c1dc.svg";
export { ForwardRef as ReactComponent };